import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import FormInput from 'src/hook-form-wrapper/form-input';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
}

export const Import = (
  key: string = 'programTargets',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Targets',
  key,
  description:
    'Targets should be included in a comma separated list ex. Airplane,Bus,Car',
});

export const Value = (value: string) => {
  return value;
};

export const Display = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Program Targets</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  return (
    <FormInput
      name={(name ? name + '.' : '') + 'programTargets'}
      label={'Program Targets'}
      placeholder={'Program Targets'}
      helper={'Individual data points to be collected on'}
      required={false}
    />
  );
};

export const validation = () =>
  Yup.string().required('Program Targets are required');

export default Input;
